export enum ChartModuleTypesEnum {
    REPORTS,
    SHARED_REPORTS,
    SOCIAL,
    MAD,
    CIB,
    CANVAS
}
